import React from 'react';

export const ShutterCombinationFrame = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path fill="#ecf7f9" d="M64.8 31.4L20.2 3.8h-6.1l48.4 30.7z" />
        <path fill="#c8dfeb" d="M14.1 3.8L-14.5 1l68 45.7 12.7-10.1z" />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.998}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M49.8 39.4v4.9l4.9-2z"
        />
        <g
          fill="#414142"
          stroke="#241f20"
          strokeWidth={0.998}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M72.8 42.3l-8.2-5.2L60 34v5.5l8.3 5.8 4.5-3" />
          <path d="M72.8 42.3L60 34l5.7-3.1 12.7 7.7" />
        </g>
        <path
          fill="#bbbebf"
          stroke="#233762"
          strokeWidth={0.998}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M56.5 53.3L55.3 97l35.3-.1-.1-20.7-34-22.9 21.9-14.7 12.1 7.2v30.4"
        />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.897}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M43.8 48.2L23.3 35.1l9.2-4.7 20.1 13z"
        />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.897}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M24.1 34.7L-13.6 9.6l-.9-8.6 45.9 29.7z"
        />
        <g
          stroke="#233762"
          strokeWidth={0.998}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path fill="#fff" d="M11.5 97h-25.3l.1-87.9 37.5 25.3-.9.6 3.2 62z" />
          <path fill="none" d="M26.1 97h-7.8l-32.1-26.6M-13.8 85.3L1.7 97" />
          <path
            fill="#fff"
            d="M22.9 35l3.2 62h17.5l-.2-49zM-13.8 36.6l37.9 27.1M-13.8 52.5l38.9 30"
          />
        </g>
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.998}
          strokeMiterlimit={10}
          d="M43.8 48.2V97h16.5L60 59.1zM63.7 58.2V97h-3.4L60 59.1s3.2 2 3.7-.9z"
        />
        <path
          d="M51.6 38.3l-1.8 1.1 6.8-4.2 14.2 8.5-6.7 4.5-7.6 5.1 7.2 4.9s-1.4 2.6-3.7 1c-3.8-2.6-16.2-11-16.2-11l10.9-5.8-4.9-2.9"
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.998}
          strokeMiterlimit={10}
        />
        <g stroke="#233762">
          <path
            d="M51 38.5l1.7 1.1 4.4-2.8-2.1-1c-.1 0-3.9 2-4 2.7z"
            fill="#fff"
            strokeWidth={0.998}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.4 36.6c-1.3 0-4.1 1.9-4.4 2.7"
            fill="none"
            strokeWidth={0.499}
            strokeMiterlimit={10}
          />
        </g>
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
